export default __webpack_public_path__ + "static/media/important.7dfa4a70.png";